import '../../style/root/navigation.css'

import { useLocation } from 'react-router'

import { useBeamSelector } from '../../hooks'
import { BeamLogo } from '../../stories/BeamLogo'
import { BeamSideNavigation } from '../../stories/BeamSideNavigation'
import { AdminSideNavBar } from '../admin/AdminSideNavBar'
import { PartnerSideNavBar } from '../partner/PartnerSideNavBar'

interface SideNavigationProps {
  logOut?: () => void
  showLogo?: boolean
  toggleFunction?: () => void
}

export const SideNavigation = ({ showLogo, toggleFunction }: SideNavigationProps) => {
  const location = useLocation()

  const user = useBeamSelector(({ user }) => user)
  const invoices = useBeamSelector(({ invoices }) => invoices)

  const userSideNav = (pathname: string | null) => {
    const countInvoices = invoices.filter(
      (_i: any) => _i.paymentRequested === true && _i.isPaid === false
    ).length

    if (user?.partner?.name) {
      return <BeamSideNavigation pathname={pathname} user={user} toggleFunction={toggleFunction} />
    }

    switch (user.type) {
      case 'Super':
      case 'Admin':
      case 'Staff':
        return (
          <AdminSideNavBar
            pathname={pathname}
            user={user}
            toggleFunction={toggleFunction}
            invoicesCount={countInvoices}
          />
        )
      case 'Executive':
        return (
          <PartnerSideNavBar
            pathname={pathname}
            user={user}
            toggleFunction={toggleFunction}
            invoicesCount={countInvoices}
          />
        )
      case 'Engineering':
        return <PartnerSideNavBar pathname={pathname} user={user} toggleFunction={toggleFunction} />
      default:
        return null
    }
  }

  if (!user.type) return null

  return (
    <nav id="large-screen-side-nav">
      <div>
        {showLogo && <BeamLogo width="105px" height="56px" />}
        {/* <div className="nav-page-title">Partner Portal</div> */}
        {userSideNav(location?.pathname)}
      </div>
    </nav>
  )
}
